<template>
  <svg
    width="12"
    height="8"
    viewBox="0 0 12 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M10.6875 0.875H5.375C4.51206 0.875 3.8125 1.57456 3.8125 2.4375C3.8125 3.30044 4.51206 4 5.375 4H6.625C7.48794 4 8.1875 4.69955 8.1875 5.5625C8.1875 6.42544 7.48794 7.125 6.625 7.125H1.3125"
      stroke="#5BD9A4"
      stroke-width="1.1"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<script>
export default {
  name: "CurvedArrow"
};
</script>
